"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var Icon_1 = __importStar(require("../Icon"));

var progressIndicator = function progressIndicator(props) {
  var cn = classnames_1.default('emankit__progress_indicator', {
    small: props.small
  });
  var indicator = react_1.default.createElement("div", {
    className: cn
  }, react_1.default.createElement(Icon_1.default, {
    icon: Icon_1.IconType.Spinner,
    width: 56,
    height: 56
  }));
  var containerCn = classnames_1.default(props.className, 'progress_indicator_overlay', {
    emankit__overlay: props.small !== true,
    dark_bg: props.overlay === 'dark' || props.overlay === undefined,
    clean_bg: props.overlay === 'clean',
    white_bg: props.overlay === 'white',
    light_bg: props.overlay === 'light',
    local: props.local === true
  });
  return react_1.default.createElement("div", {
    className: containerCn
  }, indicator);
};

exports.default = progressIndicator;